<template>
    <input ref="postfix"
           type="text"
           :value="value"
           aria-label="postfix"
           placeholder="XX"
           @input="onInput">
</template>

<script>
import Inputmask from 'inputmask';

export default {
  name: 'input-postfix',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      instanceMask: null,
      instanceMaskForInput: null,
      error: true,
    };
  },
  mounted() {
    this.instanceMask = new Inputmask('XX', {
      definitions: {
        X: {
          validator: '[A-Za-z]',
          casing: 'upper',
        },
      },
    });
    const input = this.$refs.postfix;
    this.instanceMaskForInput = this.instanceMask.mask(input);

    if (this.value === '') {
      this.error = true;
    } else {
      this.error = false;
    }

    this.$emit('error', this.error);
  },
  beforeDestroy() {
    this.instanceMaskForInput.remove();
    this.instanceMaskForInput = null;
    this.instanceMask = null;
  },
  methods: {
    onInput() {
      const value = this.instanceMaskForInput.unmaskedvalue();
      if (value.length < 2) {
        if (this.error !== true) {
          this.$emit('input', 'XX');
        }
        this.error = true;
      } else {
        this.error = false;
        this.$emit('input', value);
      }

      this.$emit('error', this.error);
    },
  },
};
</script>

<style scoped>

</style>
